import * as ChannelsRoutes from './channels';
import { Auth as _Auth } from './auth';
import { Users as _Users } from './users';
import { Roles as _Roles } from './roles';
import { Chats as _Chats } from './chats';
import { Files as _Files } from './files';
import { Settings as _Settings } from './settings';
import { Notifications as _Notifications } from './notifications';
import { WhatsApp as _WhatsApp } from './whatsapp';
import { Exports as _Exports } from './exports';
import { Persons as _Persons } from './persons';
import { Messages as _Messages } from './messages';
import * as _Stats from './stats';
import { Bots as _Bots } from './bots';

// Temporary for old types before all migrated to namespaces
export { ChannelsAccountGetResponse, ChannelsAccountPostBody, ChannelsAccountPostResponse, ChannelsAccountsGetResponse, ChannelsAdaptersGetResponse } from './channels';
export {
    ChatsCountQuery, ChatsCountResponse, ChatUpdateResponse, ChatAssignBody, ChatAssignResponse,
    ChatResolveBody, ChatResolveResponse, ChatsBulkResolveBody, ChatsBulkResolveResponse, ChatGetResponse,
    ChatCreateBody, ChatCreateResponse, ChatPatchResponse, ChatSubscribeBody, ChatSetReadBody, ChatSetReadResponse,
    ChatsGetUnsubscribedBody, ChatsGetUnsubscribedResponse, ChatNoteBody, ChatAddNoteResponse, ChatGetNotesResponse,
    ChatEditNoteResponse, ChatDeleteNoteResponse, ChatRunBotBody, ChatPatchBody, ChatsGetQuery, ChatsGetResponse, BOT_AGENT_FILTER_UID,
} from './chats';
export {
    isMessagesGetWithIdQuery, isMessagesGetBeforeQuery, isMessagesGetAfterQuery, MessagesGetQuery, MessagesGetResponse,
    MessagesSearchQuery, MessagesSearchResponse, MessageSearchItem, MessageSendBody, MessagesSendBody, MessagesSendResponse,
} from './messages';
export { FileShareResponse, FilesUploadResponse } from './files';
export * from './events';
export * from './crm';
export * from './templates';
export * from './stats';
export * from './channels';
export { WhatsAppChannelGetFeaturesResponse, WhatsAppChannelGetPhoneInfoResponse, TemplateCreateBody, TemplatePatchBody, TemplateLocalizationCreateBody, TemplateLocalizationPatchBody } from './whatsapp';
export * from './schedule';
export * from './schedule';
export * from './departments';
export * from './persons';
export interface BadRequestErrorResponse {
    error: string;
}

export namespace Routes {

    export import Auth = _Auth;

    export import Channels = ChannelsRoutes;

    export import Users = _Users;

    export import Roles = _Roles;

    export import Chats = _Chats;

    export import Files = _Files;

    export import Notifications = _Notifications;

    export import WhatsApp = _WhatsApp;

    export import Settings = _Settings;

    export import Exports = _Exports;

    export import Persons = _Persons;

    export import Messages = _Messages;

    export import Stats = _Stats;

    export import Bots = _Bots;
}
